var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SearchGroups'),_c('ListCardGroups',{attrs:{"groups":_vm.groups}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }